import React, {useEffect} from 'react';
import cx from 'classnames';
import {
    Flex,
    Text,
    Button,
    AIStarIcon,
    PriorityIcon
} from '@priority-software/priority-style-react';
import styles from '../styles/RecommendedSearch.module.scss';
import {createSearchFromRecommendation} from '../services/searchesService';
import {Form} from '../../../_legacy/Form/stores/Form';
import {monitorAction} from '../../../services/datadog';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {RecommendedSearchMonitoring} from '../../../constants/monitoring';
import {SearchesStore} from '../../../_legacy/Searches/stores/SearchesStore';
import {IndexedSearch} from '../../../services/indexDB/indexeddbServiceSearches';
import {FiltersList} from '../../../features/Personalization/components/FiltersList';
import {SuggestionType} from '../../../features/Personalization/types/personalizationCenter';
import {convertFilterValsToText} from '../../../features/Personalization/utils/personalization';
import {resetPersonalizationSuggestion} from '../../../services/indexDB/indexeddbPersonalizationCenter';
import {addSearchToServerBlacklist} from '../../../features/Personalization/service/searchesBlacklistService';

type Props = {
    form: Form;
    searchesStore: SearchesStore;
    recommendedSearch: IndexedSearch;
    showRecommendedSearch: boolean;
    toggleRecommendedSearch: () => void;
};

export const RecommendedSearch = ({
    searchesStore,
    form,
    recommendedSearch,
    showRecommendedSearch,
    toggleRecommendedSearch
}: Props) => {
    useEffect(() => {
        monitorAction(RecommendedSearchMonitoring.recommendationDisplayed);
    }, []);

    const filtersTextValues = recommendedSearch?.filters?.map(filter => {
        return convertFilterValsToText(form, filter);
    });

    return (
        <>
            <Button
                skin="text"
                onClick={toggleRecommendedSearch}
                prefixIcon={<AIStarIcon />}
                suffixIcon={
                    showRecommendedSearch ? PriorityIcon.arrowUpThin : PriorityIcon.arrowBottomThin
                }
                componentClasses={cx(styles.recommendationToggler, [styles.openRecommendation])}
            >
                <Text skin="paragraph-2">{getLocalizedText(texts.recommendationForYou)}</Text>
            </Button>
            {showRecommendedSearch && (
                <div className={styles.recommendationWrapper}>
                    <Flex componentClasses={styles.content} direction="column">
                        <Flex
                            justifyContent="flex-start"
                            componentClasses={styles.recommendationHeader}
                        >
                            <AIStarIcon />
                            <Text skin="paragraph-2" textColor="primary-500">
                                {getLocalizedText(texts.recommendationForYou)}
                            </Text>
                        </Flex>
                        <Text componentClasses={styles.recommendationPreText}>
                            {getLocalizedText(texts.recommendationPreText)}
                        </Text>
                        {filtersTextValues && <FiltersList filters={filtersTextValues} />}
                        <Button
                            size="medium"
                            componentClasses={styles.createBtn}
                            onClick={async () => {
                                searchesStore.setRecommendedSearch(null);
                                await addSearchToServerBlacklist(form.name, recommendedSearch);
                                resetPersonalizationSuggestion(SuggestionType.Searches);
                                createSearchFromRecommendation(
                                    searchesStore,
                                    form,
                                    recommendedSearch
                                );
                                monitorAction(RecommendedSearchMonitoring.recommendationApplied);
                            }}
                        >
                            {getLocalizedText(texts.recommendationCreate)}
                        </Button>
                    </Flex>
                </div>
            )}
        </>
    );
};
